import React from 'react';
import styles from './login.module.css';
import axios from 'axios'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Snackbar from '../../utils/snackbar/Snackbar';
import {withRouter} from 'react-router-dom'
import {setUser} from '../../../containers/app/actions'
import {connect} from 'react-redux';

const Login = (props) => {
    const [formData,setFormData] = React.useState({
        contactNum: "",
        password: ""
    });
    const [err,setErr] = React.useState({
        contactNum: false,
        password: false
    })
    
    const [loading,setLoading] = React.useState(false)
    const [alert,setAlert] = React.useState(false);

    React.useEffect(() => {
        if(props.user) {
            props.history.push("/admin/dashboard")
        }
    },[props.user])

    const validate = () => { 
        let valid = true;
        let error = {contactNum: false,password: false};
        Object.keys(formData).map(key => {
            if(formData[key] == "") { 
                error[key] = `* ${key} field cannot be empty`;
                valid = false;
            }
        });
        setErr({...error})
        return valid;
    } 

    const onSubmit = () => {
        if(validate()) {
            // const headers = {
            //     "Access-Control-Allow-Origin": "*"
            //   }
            setLoading(true);
            axios({
                method: "post",
                url: "/loginApi",
                nonAuth: true,
                data: {
                    ...formData
                }
            }).then(res => { 
                if(res.data.success) {
                    setAlert("Logged in Successfully");
                    localStorage.setItem("user",JSON.stringify(res.data.data.contactNum))
                    props.setUser(res.data.data)
                    props.history.push("/admin/dashboard")
                } else { 
                    setAlert(res.data.msg)
                }
                setLoading(false); 
            }).catch(err => {
                setLoading(false); 
            })
        }
    }
    return (
        <div className={styles.container}>
            <Snackbar open={alert} onClose={() => setAlert(false)} />
            <div className={styles.content}>
                <Paper className={styles.paper} variant="outlined">
                    <h1>Login</h1>

                    <TextField 
                        value={formData.contactNum}
                        label="Enter Contact Number"
                        type="text"
                        onChange={(e) => {
                            e.target.value.length <= 10 && setFormData({...formData,contactNum: e.target.value.replace(/\D/,'')})
                        }}
                        helperText={err.contactNum}
                        error={err.contactNum}
                        className={styles.textField}
                        fullWidth
                    />

                    <TextField 
                        value={formData.password}
                        type="password"
                        label="Enter Password"
                        onChange={(e) => setFormData({...formData,password: e.target.value})}
                        helperText={err.password}
                        error={err.password}
                        className={styles.textField}
                        fullWidth
                    />

                    <div className={styles.contentSpace}>
                    {/* <Button color="primary" onClick={() => props.history.push("/register")}>Register Here</Button> */}
                        {loading 
                            ?
                        <Button variant="contained" color="primary">Loading...</Button>
                            :
                        <Button variant="contained" color="primary" onClick={onSubmit}>Login</Button>}
                    </div>
                </Paper>
            </div>         
        </div>
    )
}
const mapStateToProps = state => ({
    user: state.appReducer.user
});
export default withRouter(connect(mapStateToProps,{setUser})(Login));